import React from "react";
import PropTypes from "prop-types";
import Button from "antd/lib/button";
import FormOutlinedIcon from "@ant-design/icons/FormOutlined";
import { useTheme } from "@/components/ThemeProvider";
import "./EditVisualizationButton.less";

export default function EditVisualizationButton(props) {
  const { isDarkMode } = useTheme();

  return (
    <Button
      data-test="EditVisualization"
      className={`edit-visualization ${isDarkMode ? 'dark-mode' : ''}`}
      onClick={() => props.openVisualizationEditor(props.selectedTab)}>
      <FormOutlinedIcon />
      <span className="hidden-xs hidden-s hidden-m">Edit Visualization</span>
    </Button>
  );
}

EditVisualizationButton.propTypes = {
  openVisualizationEditor: PropTypes.func.isRequired,
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

EditVisualizationButton.defaultProps = {
  selectedTab: "",
};
